import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {assignCrmStaff, getProviderStaff, removeCrmStaff} from "../../../../store/crm/staff";
import {changeAppointmentStatus, getAllAppointment, getAppointmentDetails, getAppointmentHistory, getAppointmentcalender} from "../../../../store/crm/appointment";
import {MySwal, successConfirmation} from "../../../../services/utills";
import CustomButtoncolor from "../../../../components/custom-button/customColorButton";
import CustomModal from "../../../../components/modal/customModal";
import Box from "@mui/material/Box";
import {Avatar, Button, Checkbox, FormControlLabel, FormGroup, Grid, IconButton, Typography} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {ReactComponent as Close} from "../../../../assets/icon/close-outline.svg";
import {useNavigate} from "react-router";
import Waveloading from '../../../loading/Waveloading';
import { useMediaQuery } from '@mui/material'; // Import the hook for media queries
import EditIcon from '@mui/icons-material/Edit';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import {apiHeaders} from "../../../../lib/apiHeader"
import { getCRMCustomerBookingsDetails } from '../../../../store/crm/crm';
import Customcolorbtn from '../../../../components/custom-button/customeColorCalender';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
import toast from 'react-hot-toast';
// import toast from 'react-hot-toast';

const AppointmentStaffcalender = ({  isbtn ,appointment,label,isFetch,isAppointment,value,isNoShow,mainColor,fetchAppointment,fetchCalenderBookings, fwidth, onRescheduleSuccess, panelMode, onPanelClose, onActionStart, onActionEnd}) => {

    const [loading, setLoading] = useState(false)
    const [staffModal, setStaffModal] = useState(false)
    const [selectedStaff, setSelectedStaff] = useState(null)


      // Using useMediaQuery hook to check if screen width is 340px or smaller
  const isSmallScreen = useMediaQuery('(max-width:348px)')

    const isStaff = value === 'CheckIn' && !appointment?.staff?.id
    const dispatch = useDispatch()   
    const navigate = useNavigate()  
       
    const crmStaffStore = useSelector(state => state?.crmStaffStore)
    const {crmStaffs = []} = crmStaffStore   

    /********************* Staff **************************/ 
 const scrollRef = useRef(null);  
    useEffect(() => {

        (async () => {
            if (!crmStaffs?.length && staffModal && (value === 'CheckIn' || !value)) {
                await dispatch(getProviderStaff())
                setLoading(false)
            }
        })()
    }, [staffModal])

    useEffect(() => {
        if (panelMode && (!value || value === 'CheckIn') && !crmStaffs?.length) {
            setLoading(true)
            dispatch(getProviderStaff()).then(() => setLoading(false))
        }
    }, [])

    const autoTriggeredRef = useRef(false)
    useEffect(() => {
        if (autoTriggeredRef.current) return
        if (panelMode && value) {
            autoTriggeredRef.current = true
            if (isStaff) {
                // Check-In was clicked without a staff assigned — instead of erroring,
                // let the panel render the staff selection grid so the user can pick
                // one. Selecting a staff fires the assign + check-in API in one step.
                if (!crmStaffs?.length) {
                    setLoading(true)
                    dispatch(getProviderStaff()).then(() => setLoading(false))
                }
                return
            }
            handleChangeStatus()
        }
    }, [])



    const handleOpen = () => { 
        if (!crmStaffs?.length) {
            setLoading(true)
        }
        if (appointment?.id && !value){
            if (appointment?.staff?.id){
                setSelectedStaff(appointment?.staff)
            }else {
                setSelectedStaff(null)
            }
        }
        setStaffModal(true)
    }
    const handleClose = () => {
        setSelectedStaff(null)
        setStaffModal(false)
    }
    // //console.log("data customer id",appointment)
    const handleAssign = async (staffOverride) => {
        const staffToUse = staffOverride !== undefined ? staffOverride : selectedStaff;

        if (appointment?.id) {
            if (panelMode) {
                const fd = {
                    appointment_id: appointment?.id,
                    staff_id: staffToUse ? staffToUse?.id : null
                }
                if (isStaff) { fd['status'] = 'CheckIn' }
                onActionStart?.()
                dispatch(assignCrmStaff(fd)).then(res => {
                    // Parent's onActionEnd already runs refreshOpenAppointment() +
                    // reloadCalendar() in parallel — don't refetch here.
                    onActionEnd?.(res?.payload?.success === 'true' ? (isStaff ? 'Staff assigned and checked in successfully!' : 'Staff assigned successfully!') : null)
                })
                return
            }
            setLoading(true)
            let finalData = {
                appointment_id: appointment?.id,
                staff_id: staffToUse ? staffToUse?.id : null
            }

            if (isStaff){
                finalData['status'] = 'CheckIn'
            }
            let res = await dispatch(assignCrmStaff(finalData))
            await dispatch( getAllAppointment())
            //console.log("appoint id",appointment)
            if (res?.payload?.success === 'true') {
                if(isAppointment){
                    await dispatch (getAppointmentHistory({
                        user_id:appointment?.customer?.id,type:'Appointments'
                    }))
                    await dispatch(getCRMCustomerBookingsDetails({id:appointment?.customer?.id,type:'Appointments'}))
                }
          
     
                if (isFetch) {
                    //console.log("isfetch",isFetch)
                    await dispatch(getAppointmentDetails(appointment?.id))
                    await  dispatch(getAllAppointment())
                }      
                if (fetchCalenderBookings){   
                    await fetchCalenderBookings() 
                    await dispatch(getAppointmentcalender(appointment?.id))
                }
                await  dispatch(getAllAppointment())
               
                toast.success(
                    isStaff ?
                        'Staff assigned and checked in successfully!'
                        : "Staff assigned successfully!"
                )
                if (panelMode) { onPanelClose?.(); } else { handleClose(); }

            }

            setLoading(false)
        }
    } 

    const handelremoveStaff = async () => {
        if (appointment?.id) {
            if (panelMode) { onActionStart?.(); } else { setLoading(true); }

            let finalData = {
                appointment_id: appointment?.id,
                staff_id: selectedStaff ? selectedStaff?.id : null
            };

            if (isStaff){
                finalData['status'] = 'CheckIn'
            }

            const API_ENDPOINT = '${BACKEND_URL}crm/appointments/remove-staff';

            try {
                const res = await fetch(API_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...apiHeaders(),
                    },
                    body: JSON.stringify(finalData),
                });

                const result = await res.json();
                if (result?.success === 'true') {
                    if (panelMode) {
                        onActionEnd?.('Assigned staff removed successfully.');
                        return;
                    }
                    await dispatch(getAppointmentcalender(appointment?.id))
                    if (isFetch) {
                        await dispatch(getAppointmentDetails(appointment?.id));
                    } else {
                        dispatch(getAppointmentDetails(appointment?.id));
                    }
                    if (fetchCalenderBookings) {
                        await fetchCalenderBookings();
                    }

                    await dispatch(getAllAppointment({start_date:"null",end_date:"null"}))
                    await dispatch (getAppointmentHistory({
                        user_id:appointment?.customer?.id,type:'Appointments'
                    }))
                    await dispatch (getCRMCustomerBookingsDetails({
                        id:appointment?.customer?.id,type:'Appointments'
                    }))
                    toast.success(" Assigned staff remove successfully.");
                    handleClose();
                } else if (panelMode) {
                    onActionEnd?.(null);
                }
            } catch (error) {
                console.error("Error in removeCrmStaff:", error);
                if (panelMode) { onActionEnd?.(null); }
            }

            if (!panelMode) { setLoading(false); }
        }
    };
    
    
//console.log("status comes",{label})
    /********************* Status **************************/
    function getConfirmTitle(label) {
        //console.log("label coming",label)
        switch (label) {
          case "Cancel/Refund":
            return "Cancel / Refund ?";
          case "Check-Out":   
            return "Check Out?";
            case "Mark as No Show":
                return "No Show ?";
            case "No Show":
                return "No Show ?"
                case "Check-In":
                    return "Check In ?"
          default:
            return "Confirm Appointment?";
        }
      }
    function getConfirmSuccessMessage(label) {
        switch (label) {
            case "Cancel/Refund":
                return "Cancellation & refund processed successfully!";
            case "Check-Out":
                return "Checkout completed successfully!";
            case "Mark as No Show":
            case "No Show":
                return "Marked as No-Show successfully!";
            case "Check-In":
                return "Checked in successfully!";
            default:
                return "Appointment confirmed successfully!";
        }
    }

    function getConfirm(label) {
        //console.log("label coming",label)
        switch (label) {   
          case "Cancel/Refund": 
            return "Cancel / Refund ";
          case "Check-Out":   
            return "Check Out";
            case "Mark as No Show":
                return "No Show ";
            case "No Show":
                return "No Show "
                case "Check-In":
                    return "Check In "
          default:
            return " Confirm Appointment";
        }
      }

      function getIcon(label) {
        switch (label) {
          case "Cancel/Refund":
            return <CancelIcon />;
          case "Check-Out":
            return <CheckCircleIcon />;
          case "Mark as No Show":
          case "No Show":
            return <PersonAddDisabledIcon />;
          case "Check-In":
            return <CheckCircleIcon />;
          default:
            return <PersonAddIcon />;
        }
      }
    const handleChangeStatus = async () => {

        if (isStaff){
            handleOpen()
        }else {
            if (appointment?.id) {
                let finalData = {
                    appointment_id: appointment?.id,
                    status: value
                }

                if (panelMode) {
                    if (value === 'CheckOut') {
                        navigate(`/crm/appointment/checkout/${appointment?.id}`)
                    } else {
                        onActionStart?.()
                        dispatch(changeAppointmentStatus(finalData)).then(res => {
                            // Parent's onActionEnd handles both refreshOpenAppointment +
                            // reloadCalendar — skip the duplicate refetch.
                            onActionEnd?.(res?.payload?.success === "true" ? getConfirmSuccessMessage(label) : null)
                        })
                    }
                    return
                }

                let confirm = await MySwal.fire({
                    // icon: 'question',
                    title: getConfirmTitle(label),
                    showConfirmButton: false, 
                    customClass: {
                        icon: 'custom-icon-size',
                        popup: 'custom-popup-shadow', 
                        closeButton: 'custom-close-button', 
                      },
                    showCloseButton: true,
                    // showCancelButton: true,
                    html: ( 
                      <Box>
                         {/* <Typography sx={{}}>
                            Are you sure? you want to change appointment status to {label}.
                        </Typography> */}
                        <Box sx={{
                          mt: 3,
                          display: "flex",
                          flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" },
                          gap: "12px",
                          justifyContent: "center"
                        }}>
                          <Button
                            sx={{
                              background: "#27AE60",
                              color: "#fff",
                              minWidth: "150px",   // fixed width
                              border: "1px solid #27AE60",
                              borderRadius: '10px',
                              fontSize: '16px',
                              px: '20px',
                              mx: '10px',
                              boxShadow: "none",
                              "&:hover": {
                                background: "#219653",
                                color: "#fff",
                                border: "1px solid #27AE60",
                                boxShadow: "none",
                              },
                            }}
                            onClick={() => MySwal.clickConfirm()}
                          >
                            YES
                             </Button>
                          <Button
                            sx={{
                              backgroundColor: "#EB5757",
                              color: "#fff",
                              minWidth: "150px",   // fixed width
                              border: "1px solid #EB5757",
                              borderRadius: '10px',
                              fontSize: '16px',
                              px: '20px',
                              mx: '10px',
                              boxShadow: "none",
                              "&:hover": {
                                backgroundColor: "#fff",
                                color: "#EB5757",
                                border: "1px solid #EB5757",
                                boxShadow: "none",
                              },
                            }}
                            onClick={() => MySwal.close()}
                          >
                            NO
                          </Button>
                        </Box>
                      </Box>
                    )
                  });
                            
                  
                  // Add this CSS somewhere globally (or inline if needed)
                
                  
                if (!!confirm?.isConfirmed) {
                    if (value === 'CheckOut'){
                        navigate(`/crm/appointment/checkout/${appointment?.id}`)
                    }else {
                        setLoading(true)
                        let res = await dispatch(changeAppointmentStatus(finalData))
                       
                        if (res?.payload?.success === "true") {
                            
                            if (isFetch) {
                                //console.log("console 1")
                                fetchAppointment()
                                await dispatch(getAppointmentDetails(appointment?.id)) 
                                await dispatch(getAllAppointment())
                            } 
                           
                            if (fetchCalenderBookings){
                                //console.log("console 2")
                                await dispatch(getAppointmentcalender(appointment?.id))
                                await fetchCalenderBookings()
                            }   
                            if(isAppointment){
                                //console.log("console 3")
                                await dispatch (getAppointmentHistory({  user_id:appointment?.customer?.id,type:'Appointments'}))
                                await dispatch(getCRMCustomerBookingsDetails({id:appointment?.customer?.id,type:'Appointments'}))
                            }         
                            await dispatch( getAllAppointment())
                            if (onRescheduleSuccess) {
                                await Promise.resolve(onRescheduleSuccess());
                              }

                            setLoading(false)
                            await new Promise((r) => requestAnimationFrame(() => r()));
                            toast.success(getConfirmSuccessMessage(label))
                            onPanelClose?.();
                        }
                        setLoading(false)
                    }
                }
            }
        }
    }
    const handleCheckbox = async (e) => {
        const {checked} = e.target
        if (checked){
            await handleChangeStatus()
        }
    }
    const handleStaffSelection = (staff) => {
        if (selectedStaff?.id === staff.id) {
            setSelectedStaff(null); // Unselect the staff if it's already selected
            return;
        }
        setSelectedStaff(staff);
        // In panel mode, picking a staff is the confirmation — fire the assign API
        // (and Check-In, when applicable) immediately. The legacy modal flow still
        // uses the explicit "Assign Staff" button.
        if (panelMode) {
            handleAssign(staff);
        } else {
            scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    };
 
//console.log("data coming",crmStaffs)
    if (panelMode) {
        const panelHeaderSx = {display:'flex',alignItems:'center',px:2,py:1.5,borderBottom:'1px solid #eef0f4',flexShrink:0};
        const closeBtn = (
            <IconButton size="small" onClick={() => onPanelClose?.()} sx={{color:'#9A9797','&:hover':{color:'#EB5757',background:'#ffeaea'}}}>
                <CloseIcon sx={{fontSize:18}} />
            </IconButton>
        );
        if (value && !isStaff) {
            return null;
        }
        const hasStaff = !!appointment?.staff?.id;
        const headerTitle = isStaff ? 'Assign Staff to Check In' : (hasStaff ? 'Edit Staff' : 'Assign Staff');
        const headerSubtitle = isStaff
            ? 'Tap a staff member to assign and check in.'
            : 'Tap a staff member to assign instantly.';
        return (
            <Box sx={{display:'flex',flexDirection:'column',height:'100%',background:'#fff'}}>
                {/* Header */}
                <Box sx={{position:'relative', display:'flex', alignItems:'flex-start', gap:1.25, px:2.5, py:2, borderBottom:'1px solid #F1F2F6', flexShrink:0}}>
                    <Box sx={{width:42, height:42, borderRadius:'10px', background:'#F4DDE8', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
                        <PersonAddIcon sx={{color:'#A72C68', fontSize:22}} />
                    </Box>
                    <Box sx={{flex:1, pr:3}}>
                        <Typography sx={{fontWeight:700, fontSize:'18px', color:'#1a1a2e', lineHeight:1.2, fontFamily:'helvetica-lt-std-bold,sans-serif'}}>
                            {headerTitle}
                        </Typography>
                        <Typography sx={{fontSize:'12px', color:'#8a8d97', mt:'2px'}}>
                            {headerSubtitle}
                        </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => onPanelClose?.()} sx={{position:'absolute', top:10, right:10, color:'#9A9797','&:hover':{color:'#EB5757', background:'#ffeaea'}}}>
                        <CloseIcon sx={{fontSize:18}} />
                    </IconButton>
                </Box>

                {loading && !panelMode && <Waveloading />}

                <Box sx={{flex:1, overflow:'auto', p:2.5}}>
                    {/* Remove Staff (only when one is already assigned) */}
                    {hasStaff && (
                        <Box sx={{display:'flex', gap:1, mb:2}}>
                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={() => handelremoveStaff()}
                                startIcon={<HighlightOffIcon sx={{fontSize:'16px !important'}} />}
                                sx={{
                                    color:'#EB5757', borderColor:'#FFD3D3', background:'#FFF5F5',
                                    textTransform:'none', borderRadius:'10px', py:1.25, fontWeight:600, fontSize:'13px',
                                    '&:hover':{background:'#FFEAEA', borderColor:'#EB5757'},
                                }}
                            >
                                Remove Staff
                            </Button>
                        </Box>
                    )}

                    {isStaff && <Typography sx={{color:'#A72C68', textAlign:'center', mb:2, fontSize:'12px', fontWeight:600, background:'#FAEFF5', border:'1px solid #F0CDDB', borderRadius:'8px', py:1, px:1.5}}>Pick a staff member to complete Check-In.</Typography>}

                    {/* Staff grid */}
                    {crmStaffs?.length > 0 ? (
                        <Grid container spacing={1.5}>
                            {crmStaffs.map((staff, index) => {
                                const isSelected = selectedStaff?.id === staff?.id;
                                return (
                                    <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
                                        <Box
                                            onClick={() => handleStaffSelection(staff)}
                                            sx={{
                                                position:'relative',
                                                cursor:'pointer',
                                                background:'#fff',
                                                border: isSelected ? '2px solid #A72C68' : '1px solid #F0F1F4',
                                                borderRadius:'12px',
                                                overflow:'hidden',
                                                boxShadow:'0 1px 3px rgba(0,0,0,0.04)',
                                                transition:'border-color 0.15s, box-shadow 0.15s',
                                                '&:hover':{borderColor:'#A72C68', boxShadow:'0 4px 10px rgba(167,44,104,0.10)'},
                                            }}
                                        >
                                            <Box sx={{
                                                position:'absolute', top:8, right:8, zIndex:1,
                                                width:22, height:22, borderRadius:'6px',
                                                background: isSelected ? '#A72C68' : 'rgba(255,255,255,0.95)',
                                                border: isSelected ? '1px solid #A72C68' : '1px solid #d6d8de',
                                                display:'flex', alignItems:'center', justifyContent:'center',
                                                boxShadow: isSelected ? '0 2px 4px rgba(167,44,104,0.30)' : '0 1px 2px rgba(0,0,0,0.08)',
                                            }}>
                                                {isSelected && <CheckCircleIcon sx={{color:'#fff', fontSize:16}} />}
                                            </Box>
                                            <Box sx={{width:'100%', aspectRatio:'1 / 1', overflow:'hidden', background:'#F4F5F8'}}>
                                                <Avatar src={staff?.profile_image} variant="square" sx={{width:'100%', height:'100%'}} />
                                            </Box>
                                            <Typography sx={{
                                                py:1.25, px:1,
                                                fontSize:'13px', fontWeight:600, color:'#1a1a2e',
                                                textAlign:'center',
                                                whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis',
                                            }}>
                                                {staff?.name}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    ) : <Typography sx={{textAlign:'center', mt:'24px', color:'#9ca3af', fontSize:'13px'}}>No Staff Found</Typography>}
                </Box>
            </Box>
        );
    }

    return (
        <Box>
            {loading ? <Waveloading fullSize/> : ''}
            {value ? (
  <Box>
    {isNoShow ? (
      <FormGroup>
        <FormControlLabel
          control={<Checkbox onChange={(e) => handleCheckbox(e)} />}
          label={label}
        />
      </FormGroup>
    ) : mainColor ? (
      <Customcolorbtn
        handleClick={() => handleChangeStatus()}
        mainColor={mainColor}
        style={{ borderRadius: "4px", width: fwidth, padding: "10px 15px", width: fwidth, padding: isSmallScreen ? '10px 3px' : '10px 5px',  }}
        val={isbtn ? getConfirm(label) : label} // ✅ updated label if isbtn true
        icon={isbtn ? getIcon(label) : null} // ✅ show icon conditionally
      />
    ) : (
      <Customcolorbtn
        handleClick={() => handleChangeStatus()}
        style={{ borderRadius: "4px", width: fwidth, padding: "10px 15px", width: fwidth, padding: isSmallScreen ? '10px 3px' : '10px 5px',  }}
        val={isbtn ? getConfirm(label) : label} // ✅ updated label if isbtn true
        icon={isbtn ? getIcon(label) : null} // ✅ show icon conditionally
      />
    )}
  </Box>
) : (
  <Box>
    <Customcolorbtn
      style={{ borderRadius: "4px", padding: "10px 15px", width: fwidth, padding: isSmallScreen ? '10px 3px' : '10px 15px',  }}
      mainColor={"#323681"}
      val={appointment?.staff?.id ? "Edit Staff" : "Assign Staff"}
      handleClick={() => handleOpen()}
      icon={
        isbtn
          ? appointment?.staff?.id
            ? <EditIcon />
            : <PersonAddIcon />
          : null
      }
        
      size={"medium"}

    />     
  </Box>
)}

            <CustomModal
                customWidth={'943px'}
                isCloseHide
                setOpen={() => handleClose()}
                open={!loading && staffModal}
            >
                <Box>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: '15px 15px'
                    }}>
                        {crmStaffs?.length > 0 &&
                            <Typography
                                sx={{fontSize: '18px', textAlign: 'center'}}
                            >
                                Select Staff Member
                            </Typography>}
                        <IconButton    
                            size="small"
                            onClick={() => handleClose()}
                        >
                            <Close/>
                        </IconButton>
                    </Box>
                    {isStaff && <Typography sx={{color:'red',textAlign:'center',mt:"-20px",mb:"16px"}}>Please choose  staff and then CheckIn</Typography>}
                    {crmStaffs?.length > 0 ?
                        <Grid container spacing={3}>
                            {crmStaffs.map((staff, index) => (
                                <Grid item lg={4} xs={12} key={index} sx={{cursor: 'pointer',mt: selectedStaff?.id === staff?.id ? '-59px':''}}>
                                    {selectedStaff?.id === staff?.id && 
                                    <CheckCircleIcon
                                        sx={{
                                            color: '#128D64',
                                            fontSize: '35px',
                                            position: 'relative',
                                            zIndex: '1',
                                            top:'57px',
                                            m: '10px'
                                        }}
                                    />}
                                    <Avatar
                                    
                                        onClick={() => handleStaffSelection(staff)}
                                        sx={{width: "100%", height: '160px',}}
                                        variant="rounded"
                                        src={staff?.profile_image}
                                    />
                                    <Typography
                                        sx={{
                                            textAlign:'center',
                                            mt:'10px',
                                            maxWidth:'160px',
                                        }}>
                                        {staff?.name}
                                    </Typography>
                                </Grid>
                            ))}
                            <Grid ref={scrollRef} item xs={12} sx={{display: "flex", justifyContent: "center",flexDirection:{lg:"row",sm:"row",xs:"column"},gap:{lg:"15px",sm:"15px",xs:"10px"}}}>
                                <CustomButtoncolor
                                    style={{borderRadius: "0px", minWidth: '200px',}}
                                    mainColor={"#235449"}
                                    val={isStaff ? 'Assign Staff and Check-In'  :"Assign Staff"}
                                    handleClick={() => handleAssign()}
                                    size={"medium"}
                                />

{appointment?.staff?.id && (
    // <div style={{marginLeft:"20px"}}>
  <CustomButtoncolor
                            style={{borderRadius: "0px", minWidth: '200px', }}
                            mainColor={"#FF6347"} // Adjust color as needed
                            val={"Remove Staff"}
                            handleClick={() => handelremoveStaff()}
                            size={"medium"}
                        />
    // </div>
                      
                    )}
                            </Grid>
                        </Grid>
                        :
                        <Typography>No Staff Found</Typography>
                    }
                </Box>
            </CustomModal>
        </Box>
    );
}

export default AppointmentStaffcalender;